import { formatterRegistry } from '@/utils/formatters';

export interface DeltaBadgeProps {
  value: number | null | undefined;
  prefix?: string;
  suffix?: string;
  colorUp?: string;
  colorDown?: string;
  colorNeutral?: string;
  useMillions?: boolean;
  millionsFrom?: number;
  decimalPlaces?: number | null;
}

const DEFAULT_COLOR_UP = '#28a745';
const DEFAULT_COLOR_DOWN = '#dc3545';
const DEFAULT_COLOR_NEUTRAL = '#6c757d';

function withAlpha20(color: string): string {
  const hex = color.startsWith('#') ? color : `#${color}`;
  return `${hex}20`;
}

export function DeltaBadge({
  value,
  prefix,
  suffix,
  colorUp,
  colorDown,
  colorNeutral,
  useMillions,
  millionsFrom,
  decimalPlaces,
}: DeltaBadgeProps) {
  let color: string;
  let arrowClass: string | null;

  if (value === null || value === undefined) {
    color = colorNeutral ?? DEFAULT_COLOR_NEUTRAL;
    arrowClass = null;
  } else if (value > 0) {
    color = colorUp ?? DEFAULT_COLOR_UP;
    arrowClass = 'las la-arrow-up';
  } else if (value < 0) {
    color = colorDown ?? DEFAULT_COLOR_DOWN;
    arrowClass = 'las la-arrow-down';
  } else {
    color = colorNeutral ?? DEFAULT_COLOR_NEUTRAL;
    arrowClass = null;
  }

  const formatted = formatterRegistry.format('delta', value, {
    useMillions,
    millionsFrom,
    decimalPlaces,
  });

  return (
    <div
      data-testid="delta-badge"
      className="badge"
      style={{ backgroundColor: withAlpha20(color), color }}
    >
      {arrowClass && <i className={`${arrowClass} me-1`} />}
      {prefix}
      <span style={{ fontWeight: 700 }}>{formatted}</span>
      {suffix}
    </div>
  );
}
